module.exports = __webpack_public_path__ + "static/media/blue_logo.262422bd.svg";